import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import HistoryIcon from "@mui/icons-material/History";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import {
  CssDataJacketButton,
  CssDataJacketTitleTypography,
} from "../../styles/styled";
import { useNavigate } from "react-router-dom";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { CssDataJacketBodyChip } from "../../styles/styled";
import { CssDataJacketBodyTypography } from "../../styles/styled";

const SxLeft = {
  backgroundColor: "#53565A",
  width: "40%",
  whiteSpace: "pre-wrap",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const CssButton = styled(Button)({
  marginTop: "8px",
  display: "block",
  position: "absolute",
  right: 16,
  width: "5px",
  height: "35px",
  backgroundColor: "grey",
});

const SxRight = {
  width: "60%",
  display: "flex",
  paddingLeft: "20px",
  paddingRight: "15px",
  alignItems: "center",
};

const SxRow = {
  display: "flex",
  flexDirection: "row",
  padding: "2px 0px",
  borderBottom: "1px dotted #53565A",
};

const CssTypography = styled(Typography)({
  color: "white",
});

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    maxWidth: 220,
  },
}));

function txtlimit(text, length) {
  if (text === null || text === undefined) {
    return text;
  }

  const a = text.substr(0, length) + (text.length > length ? "…" : "");
  return a;
}

export default function DataNetworkDetailModal({
  open,
  setOpen,
  dataJacket,
  saveNetwork,
  parentRef,
}) {
  const [dataJackets, setDataJackets] = React.useState([]);

  React.useEffect(() => {
    try {
      if (dataJacket.hasOwnProperty("data_jacket_id")) {
        if (
          dataJacket != "" &&
          (dataJackets.length === 0 ||
            dataJackets.filter(
              (e) => e.data_jacket_id === dataJacket.data_jacket_id
            ).length < 1)
        ) {
          setDataJackets(
            dataJackets.length > 0 ? [...dataJackets, dataJacket] : [dataJacket]
          );
        }
      } else if (dataJacket.hasOwnProperty("my_data_jacket_id")) {
        if (
          dataJacket != "" &&
          (dataJackets.length === 0 ||
            dataJackets.filter(
              (e) => e.my_data_jacket_id === dataJacket.my_data_jacket_id
            ).length < 1)
        ) {
          setDataJackets(
            dataJackets.length > 0 ? [...dataJackets, dataJacket] : [dataJacket]
          );
        }
      }
    } catch (e) {}
  }, [dataJacket]);

  React.useEffect(() => {
    try {
      if (open === false) {
        setDataJackets([]);
      }
    } catch (e) {}
  }, [open]);

  function filterDataJacketDetails(filterId) {
    var filter = dataJackets.filter((datajacketDetail) => {
      if (datajacketDetail.hasOwnProperty("data_jacket_id")) {
        return datajacketDetail.data_jacket_id !== filterId;
      } else if (datajacketDetail.hasOwnProperty("my_data_jacket_id")) {
        return datajacketDetail.my_data_jacket_id !== filterId;
      }
      // data_jacket_idまたはmy_data_jacket_idが存在しない場合は全てのデータを残す
    });
    setDataJackets(filter);
    if (filter.length === 0) handleClose();
  }

  function handleClose() {
    parentRef.current.elements("node").lock();
    setOpen(!open);
  }
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: "30vw",
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          top: 150,
          height: "84vh",
          width: "50vw",
          minWidth: "600px",
          boxSizing: "border-box",
          backgroundColor: "#303234",
          borderTopLeftRadius: "10px",
        },
      }}
      open={open}
      anchor="right"
    >
      <Box
        sx={{
          position: "relative",
          borderRadius: "10px",
        }}
      >
        <Box
          style={{
            height: "50px",
            backgroundColor: "#373737",
            position: "sticky",
            top: 0,
            zIndex: "1",
          }}
        >
          <Stack direction="row" spacing={2}>
            <Item>
              <CssDataJacketTitleTypography style={{ marginLeft: "32px" }}>
                ノード情報
              </CssDataJacketTitleTypography>
            </Item>
            <Item>
              <CssButton
                onClick={() => handleClose()}
                style={{ margin: "8px 8px 8px 8px" }}
              >
                <CloseIcon style={{ color: "white" }} />
              </CssButton>
            </Item>
          </Stack>
        </Box>
        {dataJackets.map((dataJacketDetail) => (
          <DataJacketDetailModal
            filterDataJacketDetails={filterDataJacketDetails}
            dataJacket={dataJacketDetail}
            saveNetwork={saveNetwork}
          />
        ))}
      </Box>
    </Drawer>
  );
}

export function DataJacketDetailModal({
  filterDataJacketDetails,
  dataJacket,
  saveNetwork,
}) {
  const navigate = useNavigate();
  function removeElementsByClass(className, length) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > length) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }
  function _navigateToPage(passId) {
    const id = passId;
    const mode = "redirect";
    navigate("/dataJacket", {
      state: {
        id,
        mode,
      },
    });
  }

  function industryChip() {
    let result = [];
    let tooltip = [];
    dataJacket.data_jacket_industry.split(",").map((industry, index) => {
      if (industry !== "" && industry !== undefined) {
        if (index < 4) {
          result.push(
            <CssDataJacketBodyChip
              style={{
                marginTop: "0",
                marginRight: "0",
                padding: "-4px -4px -4px -4px",
                backgroundColor: "#75787B",
              }}
              label={industry}
            />
          );
        } else {
          tooltip.push(
            <CssDataJacketBodyTypography style={{ color: "black" }}>
              {industry}
            </CssDataJacketBodyTypography>
          );
        }
      }
    });
    if (tooltip.length > 0) {
      result.push(
        <HtmlTooltip title={tooltip}>
          <CssDataJacketBodyChip
            style={{
              marginTop: "0",
              marginRight: "0",
              padding: "-4px -4px -4px -4px",
              backgroundColor: "#75787B",
            }}
            label={"..."}
          />
        </HtmlTooltip>
      );
    }
    return result;
  }

  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      <Box
        style={{ color: "white", borderRadius: "10px" }}
        sx={{
          borderColor: "#666666",
          borderWidth: "1px",
          borderStyle: "solid",
          position: "relative",
          backgroundColor: "black",
          width: "95%",
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          marginTop: "12px",
        }}
      >
        <Box
          style={{
            height: "50px",
            backgroundColor: "#373737",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        >
          <Stack direction="row" spacing={2}>
            <Item>
              <CssDataJacketTitleTypography style={{ marginLeft: "32px" }}>
                {txtlimit(dataJacket.data_jacket_name, 15)}
              </CssDataJacketTitleTypography>
            </Item>
            <Item>
              <CssButton
                onClick={() => {
                  if (dataJacket.hasOwnProperty("data_jacket_id")) {
                    filterDataJacketDetails(dataJacket.data_jacket_id);
                  } else if (dataJacket.hasOwnProperty("my_data_jacket_id")) {
                    filterDataJacketDetails(dataJacket.my_data_jacket_id);
                  }
                }}
                style={{ margin: "8px 8px 8px 8px" }}
              >
                <CloseIcon style={{ color: "white" }} />
              </CssButton>
            </Item>
          </Stack>
        </Box>
        <Box
          style={{
            paddingTop: "10px",
            backgroundColor: "#303234",
            borderBottomRightRadius: "10px",
            borderBottomLeftRadius: "10px",
          }}
        >
          <Grid
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
              borderBottom: "1px dotted #53565A",
              paddingBottom: "10px",
            }}
          >
            <CssTypography
              style={{
                display: "flex",
                marginRight: "8px",
                marginLeft: "8px",
                flexWrap: "wrap",
              }}
            >
              <LocalOfferIcon
                style={{
                  color: "white",
                  marginRight: "4px",
                  paddingTop: "5px",
                  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
                }}
              />
              {industryChip()}
            </CssTypography>
            <CssTypography
              style={{
                display: "flex",
                justifyContent: "right",
                marginRight: "8px",
                paddingTop: "3px",
              }}
            >
              <HistoryIcon style={{ color: "white", marginRight: "4px" }} />
              {"最終更新日：" +
                (dataJacket.hasOwnProperty("data_jacket_date_update")
                  ? dataJacket.data_jacket_date_update
                  : dataJacket.update_date)}
            </CssTypography>
          </Grid>
          <Grid sx={SxRow}>
            <CssTypography sx={SxLeft}>ジャケット（説明）</CssTypography>
            <CssTypography sx={SxRight}>
              {txtlimit(dataJacket.data_jacket_summary, 50)}
            </CssTypography>
          </Grid>
          <Grid sx={SxRow}>
            <CssTypography sx={SxLeft}>データ セットの分析方法</CssTypography>
            <CssTypography sx={SxRight}>
              {txtlimit(dataJacket.dataset_analysis, 50)}
            </CssTypography>
          </Grid>
          <Grid sx={SxRow}>
            <CssTypography sx={SxLeft}>分析ケースおよび結果概要</CssTypography>
            <CssTypography sx={SxRight}>
              {txtlimit(dataJacket.analysis_results, 50)}
            </CssTypography>
          </Grid>
          <Grid sx={SxRow}>
            {dataJacket.hasOwnProperty("data_jacket_date_update") ? (
              <CssDataJacketButton
                variant="contained"
                size="large"
                color="success"
                style={{
                  width: "80%",
                  margin: "12px auto 16px auto",
                }}
                onClick={() => {
                  saveNetwork();
                  removeElementsByClass("cytoscape-navigator", 0);
                  removeElementsByClass("popper-div", 0);
                  _navigateToPage(dataJacket.data_jacket_id);
                }}
              >
                データジャケット詳細画面へ
              </CssDataJacketButton>
            ) : (
              <div
                style={{
                  width: "80%",
                  margin: "12px auto 16px auto",
                }}
              ></div>
            )}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
